import { useRef, useState, useEffect, useMemo } from "react";
import { AudioLoader, AudioListener } from "three";
import { useThree, useLoader } from "@react-three/fiber";
import { useTexture } from "@react-three/drei";

function Sound({ url, position }) {
  const playButton = useTexture("/img/textures/playButton.png");
  const pauseButton = useTexture("/img/textures/pauseButton.png");

  const [isPlaying, setIsPlaying] = useState(false);

  const sound = useRef();
  const { camera } = useThree();
  const listener = useMemo(() => { return new AudioListener()},[]);
  const buffer = useLoader(AudioLoader, url);
  useEffect(() => {
    sound.current.setBuffer(buffer);
    sound.current.setRefDistance(0.5);
    sound.current.setLoop(true);
    camera.add(listener);
    return () => camera.remove(listener);
  }, [buffer, camera, listener]);

  useEffect(() => {
    if (isPlaying) {
      sound.current.play();
    } else {
      sound.current.pause();
    }
  }, [isPlaying]);

  return (
    <sprite position={position} scale={[0.5, 0.5, 0.5]} onPointerEnter={()=>{
        document.body.style.cursor = "pointer";
    }} 
    
    onPointerLeave={()=>{
        document.body.style.cursor = "default";
    }}

    onPointerDown={()=>{
        setIsPlaying(!isPlaying);
    }}>
      <spriteMaterial
        attach="material"
        map={isPlaying ? pauseButton : playButton}
        transparent={true}
        opacity={0.9}
      />
      <positionalAudio ref={sound} args={[listener]} />
    </sprite>
  );
}

export default Sound;
